import { Routes, Route } from "react-router-dom";

import React from "react";

import DanceStyles from "./pages/dance-styles/List";
import DanceStyleCreate from "./pages/dance-styles/Create";
import DanceStyleUpdate from "./pages/dance-styles/Update";
import DanceStyleView from "./pages/dance-styles/View";

import Home from "./Home";
import Patterns from "./pages/patterns/List";
import PatternCreate from "./pages/patterns/Create";
import PatternView from "./pages/patterns/View";
import PatternUpdate from "./pages/patterns/Update";
import VariationUpdate from "./pages/variations/Update";
import NotFound from "./pages/NotFound";
import Routines from "./pages/routines/List";
import RoutineUpdate from "./pages/routines/Update";
import RoutineView from "./pages/routines/View";
import VariationView from "./pages/variations/View";

interface RouterProps {
  groups: string[];
}

const Router: React.FC<RouterProps> = ({ groups }) => {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="/dance-styles" element={<DanceStyles groups={groups} />} />
      <Route path="/dance-styles/create" element={<DanceStyleCreate />} />
      <Route
        path="/dance-styles/:id/view"
        element={<DanceStyleView groups={groups} />}
      />
      <Route path="/dance-styles/:id/update" element={<DanceStyleUpdate />} />

      <Route path="/patterns" element={<Patterns groups={groups} />} />
      <Route path="/patterns/create" element={<PatternCreate />} />
      <Route
        path="/patterns/:id/view"
        element={<PatternView groups={groups} />}
      />
      <Route path="/patterns/:id/update" element={<PatternUpdate />} />

      <Route
        path="/variations/:id/view"
        element={<VariationView groups={groups} />}
      />
      <Route path="/variations/:id/update" element={<VariationUpdate />} />

      <Route path="/routines" element={<Routines groups={groups} />} />
      <Route path="/routines/:id/update" element={<RoutineUpdate />} />
      <Route
        path="/routines/:id/view"
        element={<RoutineView groups={groups} />}
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
